import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
    let options = {
        params: params,
        paramsSerializer: function(params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/smsLogs`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/smsLogs/${id}`, options)
        .then(response => {
            let log = jsona.deserialize(response.data);
            delete log.links;
            return log;
        });
}

function view(params) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/smsLogs/${params.id}${params.include ? '?include=' + params.include : ''}`, options)
        .then(response => {
            let log = jsona.deserialize(response.data);
            delete log.links;
            return log;
        });
}

function getStats(params) {
    let options = {
        params: params,
        paramsSerializer: function(params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/smsLogs/quickie/stats`, options)
        .then(response => {
            return response.data.data || {};
        });
}

function resend(payload) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/smsLogs/resend/sms`, payload, options)
        .then(response => {
            return response.data;
        });
}

export default {
    list,
    get,
    view,
    getStats,
    resend
};